import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent {

  @Input() hashOrigins: any[] = [];

  constructor() { }

  closeModal() {
    location.reload();
  }
}
